import { cn } from "@/lib/utils"

interface FrameworkChipsProps {
  groups: ReadonlyArray<readonly [string, unknown[]]>
  onJump: (framework: string) => void
}

/**
 * Full-width jump strip rendered above the left/right split (same spot the
 * old per-page tab strips used to occupy) — kept out of the left panel so it
 * doesn't eat into that narrower column's space. Pairs with
 * `useFrameworkGroups`/`FrameworkGroupedList`.
 */
export function FrameworkChips({ groups, onJump }: FrameworkChipsProps) {
  if (groups.length <= 1) return null

  return (
    <div className="flex flex-wrap items-center gap-1.5 px-6 py-2">
      {groups.map(([framework, items]) => (
        <button
          key={framework}
          type="button"
          onClick={() => onJump(framework)}
          className={cn(
            "shrink-0 whitespace-nowrap rounded-full border px-2.5 py-1 text-[11px] text-muted-foreground",
            "hover:bg-muted/50 hover:text-foreground",
          )}
        >
          {framework}
          <span className="ml-1 text-muted-foreground/70">{items.length}</span>
        </button>
      ))}
    </div>
  )
}
